module.exports = __webpack_public_path__ + "img/volunteer_kaz_country.e07df782.svg";